export default {
  pt: {
    'shipments.colheitaDialog.titulo': 'Adicionar colheita',
    'shipments.colheitaDialog.tituloEditar': 'Editar colheita',
    'shipments.colheitaDialog.descricao': 'Uma programação por registro: as cargas previstas são do conjunto todo, não de cada máquina.',
    'shipments.colheitaDialog.data': 'Data da colheita',
    'shipments.colheitaDialog.hora': 'Início previsto',
    'shipments.colheitaDialog.cargas': 'Cargas',
    'shipments.colheitaDialog.observacao': 'Observação',
    'shipments.colheitaDialog.equipe': 'Máquinas e operadores',
    'shipments.colheitaDialog.nenhumaMarcada': 'Nenhuma marcada',
    'shipments.colheitaDialog.marcadas_one': '{{count, number}} marcada',
    'shipments.colheitaDialog.marcadas_other': '{{count, number}} marcadas',
    'shipments.colheitaDialog.semMaquinario': 'Esta frente ainda não tem máquina nem operador no Maquinário. Adicione ao menos um para programar a colheita.',
    'shipments.colheitaDialog.semMaquina': 'Sem máquina',
    'shipments.colheitaDialog.semOperador': 'Sem operador',
    'shipments.colheitaDialog.salvando': 'Salvando...',
    'shipments.colheitaDialog.criada': 'Colheita programada.',
    'shipments.colheitaDialog.salva': 'Colheita atualizada.',
    'shipments.colheitaDialog.error.data': 'Informe a data da colheita.',
    'shipments.colheitaDialog.error.hora': 'Informe o horário previsto de início.',
    'shipments.colheitaDialog.error.cargas': 'A quantidade de cargas precisa ser um número inteiro maior que zero.',
    'shipments.colheitaDialog.error.equipe': 'Marque ao menos uma máquina ou operador.',
  },
  en: {
    'shipments.colheitaDialog.titulo': 'Add harvest',
    'shipments.colheitaDialog.tituloEditar': 'Edit harvest',
    'shipments.colheitaDialog.descricao': 'One schedule per record: the planned loads belong to the whole crew, not to each machine.',
    'shipments.colheitaDialog.data': 'Harvest date',
    'shipments.colheitaDialog.hora': 'Planned start',
    'shipments.colheitaDialog.cargas': 'Loads',
    'shipments.colheitaDialog.observacao': 'Notes',
    'shipments.colheitaDialog.equipe': 'Machines and operators',
    'shipments.colheitaDialog.nenhumaMarcada': 'None selected',
    'shipments.colheitaDialog.marcadas_one': '{{count, number}} selected',
    'shipments.colheitaDialog.marcadas_other': '{{count, number}} selected',
    'shipments.colheitaDialog.semMaquinario': 'This work front has no machine or operator yet. Add at least one to schedule the harvest.',
    'shipments.colheitaDialog.semMaquina': 'No machine',
    'shipments.colheitaDialog.semOperador': 'No operator',
    'shipments.colheitaDialog.salvando': 'Saving...',
    'shipments.colheitaDialog.criada': 'Harvest scheduled.',
    'shipments.colheitaDialog.salva': 'Harvest updated.',
    'shipments.colheitaDialog.error.data': 'Enter the harvest date.',
    'shipments.colheitaDialog.error.hora': 'Enter the planned start time.',
    'shipments.colheitaDialog.error.cargas': 'The number of loads must be a whole number greater than zero.',
    'shipments.colheitaDialog.error.equipe': 'Select at least one machine or operator.',
  },
  es: {
    'shipments.colheitaDialog.titulo': 'Agregar cosecha',
    'shipments.colheitaDialog.tituloEditar': 'Editar cosecha',
    'shipments.colheitaDialog.descricao': 'Una programación por registro: las cargas previstas son del conjunto, no de cada máquina.',
    'shipments.colheitaDialog.data': 'Fecha de la cosecha',
    'shipments.colheitaDialog.hora': 'Inicio previsto',
    'shipments.colheitaDialog.cargas': 'Cargas',
    'shipments.colheitaDialog.observacao': 'Observación',
    'shipments.colheitaDialog.equipe': 'Máquinas y operadores',
    'shipments.colheitaDialog.nenhumaMarcada': 'Ninguna seleccionada',
    'shipments.colheitaDialog.marcadas_one': '{{count, number}} seleccionada',
    'shipments.colheitaDialog.marcadas_other': '{{count, number}} seleccionadas',
    'shipments.colheitaDialog.semMaquinario': 'Este frente aún no tiene máquina ni operador. Agregue al menos uno para programar la cosecha.',
    'shipments.colheitaDialog.semMaquina': 'Sin máquina',
    'shipments.colheitaDialog.semOperador': 'Sin operador',
    'shipments.colheitaDialog.salvando': 'Guardando...',
    'shipments.colheitaDialog.criada': 'Cosecha programada.',
    'shipments.colheitaDialog.salva': 'Cosecha actualizada.',
    'shipments.colheitaDialog.error.data': 'Informe la fecha de la cosecha.',
    'shipments.colheitaDialog.error.hora': 'Informe el horario previsto de inicio.',
    'shipments.colheitaDialog.error.cargas': 'La cantidad de cargas debe ser un número entero mayor que cero.',
    'shipments.colheitaDialog.error.equipe': 'Seleccione al menos una máquina u operador.',
  },
}
